import React from 'react'
import {
  TextField
} from '@material-ui/core';

const NonPharmacologicalRecommendationsPDF = ({nonPharmacologicalRecommendationsPDF, handleChange}) => {
  return (
    <TextField  label="Recomendaciones Generales Completas"
      variant="outlined"
      name={'non_pharmacological_recommendations_pdf'}
      multiline
      fullWidth
      margin={'normal'}
      value={nonPharmacologicalRecommendationsPDF || ''}
      onChange={({target}) => handleChange(target)}
      type="text" />
  )
}

export default NonPharmacologicalRecommendationsPDF
